const initMapSimple = function() {
  var gmap = document.getElementById("map-simple");

  if (!gmap) return;

  var selectedMap = gmap.getAttribute("data-loc");

  if (!selectedMap || selectedMap == "") return;

  let position = new google.maps.LatLng(48.864716, 2.349014); // Paris, France

  loadMapDatas(selectedMap);

  const mapStyles = [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36
        },
        {
          color: "#333333"
        },
        {
          lightness: 40
        }
      ]
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on"
        },
        {
          color: "#ffffff"
        },
        {
          lightness: 16
        }
      ]
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe"
        },
        {
          lightness: 20
        }
      ]
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#fefefe"
        },
        {
          lightness: 17
        },
        {
          weight: 1.2
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5"
        },
        {
          lightness: 20
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5"
        },
        {
          lightness: 21
        }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#dedede"
        },
        {
          lightness: 21
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 17
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 29
        },
        {
          weight: 0.2
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 18
        }
      ]
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 16
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2"
        },
        {
          lightness: 19
        }
      ]
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          visibility: "on"
        },
        {
          gamma: "0.82"
        },
        {
          lightness: "-6"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#e9e9e9"
        },
        {
          lightness: 17
        }
      ]
    }
  ];

  function setupMap() {
    let infowindows = [];

    window.mapSimple = new google.maps.Map(gmap, {
      zoom: 19,
      center: position,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
      disableDefaultUI: true,
      scrollwheel: false,
      draggable: false
    });

    centerAndFitMap();
    google.maps.event.addDomListener(window, "resize", centerAndFitMap);

    function centerAndFitMap() {
      mapSimple.setCenter(position);
      //mapSimple.fitBounds(latlngbounds);
      var listener = google.maps.event.addListener(
        mapSimple,
        "idle",
        function() {
          if (mapSimple.getZoom() < 13) mapSimple.setZoom(13);
          mapSimple.setCenter(position);
          google.maps.event.removeListener(listener);
        }
      );
    }
  }

  function loadMapDatas(loc) {
    setupMap();

    geocoder = new google.maps.Geocoder();

    if (geocoder) {
      geocoder.geocode(
        {
          address: loc
        },
        (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
              position = results[0].geometry.location;
              mapSimple.setCenter(position);

              var infowindow = new google.maps.InfoWindow({
                content: "<b>" + loc + "</b>",
                size: new google.maps.Size(150, 50)
              });

              var marker = new google.maps.Marker({
                position: position,
                map: mapSimple,
                title: loc
              });
              google.maps.event.addListener(marker, "click", function() {
                infowindow.open(mapSimple, marker);
              });
            } else {
              console.error("No geocoding results found !");
            }
          } else {
            console.error(
              "Geocode was not successful for the following reason: " + status
            );
          }
        }
      );
    }
    //
  }
};

window.initMapSimple = initMapSimple;
